<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed()">
  @if (!hasOnlyOneAccount()) {
    <li nz-menu-item nzMatchRouter>
      <a routerLink="/account/list">
        <span nz-icon nzType="double-left"></span>
        <span>{{ 'shared.menu.account.list' | translate }}</span>
      </a>
    </li>
  }

  <li nz-menu-item nzMatchRouter>
    <a [routerLink]="['./account', accountId(), 'dashboard']">
      <span nz-icon nzType="dashboard"></span>
      <span>{{ 'shared.menu.account.dashboard' | translate }}</span>
    </a>
  </li>

  <moxi-ride-side-menu
    [accountId]="accountId()"
    [isCollapsed]="isCollapsed()"
  />

  @if (isAdmin()) {
    <li
      nz-submenu
      nzIcon="folder-view"
      [nzTitle]="'shared.menu.account.title' | translate"
      [nzOpen]="accountRLA.isActive"
    >
      <ul #accountRLA="routerLinkActive" routerLinkActive>
        <li nz-menu-item nzMatchRouter style="position: relative">
          <a [routerLink]="[path(), 'details']">
            {{ 'shared.menu.account.details' | translate }}
          </a>

          @if (isDispatcherDetailsIncomplete()) {
            <nz-icon
              nzType="info-circle"
              class="warning-color"
              nz-tooltip
              [nzTooltipTitle]="
                'account.details.incompleteInfoTitle' | translate
              "
            />
          }
        </li>

        @if (!hasOnlyOperatorService()) {
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="[path(), 'teams']">
              {{ 'shared.menu.account.teams' | translate }}
            </a>
          </li>
        }

        <li nz-menu-item nzMatchRouter>
          <a [routerLink]="[path(), 'users']">
            {{ 'shared.menu.account.users' | translate }}
          </a>
        </li>

        @if (hasDispatcherService()) {
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="[path(), 'drive-permissions']">
              {{ 'shared.menu.account.drivePermissions' | translate }}
            </a>

            @if (isDriverPermissionsIncomplete()) {
              <nz-icon
                nzType="info-circle"
                class="warning-color"
                nz-tooltip
                [nzTooltipTitle]="
                  'account.drivePermissions.incomplete' | translate
                "
              />
            }
          </li>
        }

        <li nz-menu-item nzMatchRouter>
          <a [routerLink]="[path(), 'subscriptions']">
            {{ 'shared.menu.account.subscriptions' | translate }}
          </a>
        </li>

        <li nz-menu-item nzMatchRouter>
          <a [routerLink]="[path(), 'tokens']">
            {{ 'shared.menu.account.tokens' | translate }}
          </a>
        </li>

        @if (hasCeliosIntegrationService()) {
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="[path(), 'integrations', 'celios']">
              {{ 'shared.menu.account.celiosIntegration' | translate }}
            </a>
          </li>
        }

        @if (hasDispoliveIntegrationService()) {
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="[path(), 'integrations', 'dispolive']">
              {{ 'shared.menu.account.dspoliveIntegration' | translate }}
            </a>
          </li>
        }
      </ul>
    </li>
  }
</ul>
